<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Product" tabActive="Comfortable & Cozy Line" bg="/images/sub/visual/sv-product.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <sub-product tit="Comfortable & Cozy Line" file="comfortable">
                싱글니트와 타월 테리, 플리스, 텍스쳐 니트 등. 브러쉬 효과와 더불어 다양한 조직을 구현합니다. 홈웨어와 더불어 다양한 룩을 연출하는 소프트 니트 라인은 소비자에게 편안함과 쾌적함을 선사합니다.
            </sub-product>
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
import SubProduct from "@/components/client/sub/sub-product.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        SubProduct,
    },
};
</script>

<style lang="scss" scoped></style>
